// React and related imports
import React from 'react';

// Flowbite UI components and icons
import { HiMoon, HiSun } from 'react-icons/hi';

// Redux selectors, hooks, and actions
import { selectIsDarkMode } from '../../redux/selectors/displaySettingsSelectors';
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { useAppDispatch } from '../../redux/hooks/useAppDispatch';
import { toggleDarkMode } from '../../redux/slices/displaySettingsSlice';

export const DarkModeToggle: React.FC = () => {
  const dispatch = useAppDispatch();
  const isDarkMode = useAppSelector(selectIsDarkMode);

  const darkModeHandler = () => {
    dispatch(toggleDarkMode());
    document.documentElement.classList.toggle('dark', !isDarkMode);
    document.body.classList.toggle('dark', isDarkMode);
  };

  return (
    <button
      onClick={darkModeHandler}
      className={`rounded-lg border border-transparent p-1.5 text-primary-900 hover:border-transparent dark:text-primary-25`}
    >
      {isDarkMode ? (
        <HiSun className="h-4 w-6" />
      ) : (
        <HiMoon className="h-4 w-6" />
      )}
    </button>
  );
};
